// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-sm[data-v-49bcde1d]{font-size:15px}.card-section[data-v-49bcde1d]{padding:0!important;overflow:hidden}.min-h-300[data-v-49bcde1d]{min-height:150px}", ""]);
// Exports
module.exports = exports;
